import { render } from "./AImage.vue?vue&type=template&id=0b6e461e&scoped=true"
import script from "./AImage.vue?vue&type=script&lang=js"
export * from "./AImage.vue?vue&type=script&lang=js"

import "./AImage.vue?vue&type=style&index=0&id=0b6e461e&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6e461e"]])

export default __exports__